import React from 'react';
import {Container, Grid, Stack, Typography} from "@mui/material";
import GenderIconMan from "../../../../../public/images/common/gender_man.svg";
import GenderIconWoman from "../../../../../public/images/common/gender_woman.svg";
import {css} from "@emotion/react";
import colorPalette from "../../../../styles/theme/colorPalette";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import LinkButton from "../../../atoms/LinkButton";

const happyReports = () => {
  return (
      <div id={'happy_report'} css={wrapper}>
        <Container css={style}>
          <div>
            <div css={{marginBottom: '32px'}}>
              <Typography variant={'h1'} css={title}>
                <span>数値改善ハッピーレポート</span>
              </Typography>
              <div css={subtitle}>
                数値改善のお声をご紹介！
              </div>
            </div>
            <div>
              <Report
                  date={'2021年6月2日'}
                  title={'クレアチニンが2.46→2.16に改善！'}
                  gender={'女性'}
                  age={'60代'}
                  situation={<span>たんぱく質調整食<br/>毎週14食</span>}
                  comment={'栄養士の先生も主治医の先生も、改善した数値を見て驚いていました。私も嬉しかったです。'}
              />
              <Report
                  date={'2021年6月1日'}
                  title={'HbA1cが15.5→9.2へ改善！'}
                  gender={'男性'}
                  age={'60代'}
                  situation={<span>ヘルシー食おかず<br/>毎週10食</span>}
                  comment={'必ず栄養成分の表示を確認するようにご指導いただき、数値が改善してよかったです。'}
              />
              <Report
                  date={'2021年5月30日'}
                  title={'リンが5.0から4.4へ改善！'}
                  gender={'女性'}
                  age={'60代'}
                  situation={<span>たんぱく質調整食おかずのみ<br/>2日に一食ずつご利用</span>}
                  comment={'検査結果も良好でHbA1cも下がり、先生もびっくりしていました。'}
              />
              <Stack alignItems={'center'} css={{marginBottom: '24px'}}>
                <LinkButton
                    text={'もっと見る'}
                    href={'/happy_reports'}
                    maxWidth={"300px"}
                    endAdornment={ <ArrowRightIcon /> }
                />
              </Stack>
            </div>
          </div>
        </Container>
      </div>
  );
};

export default happyReports;

const style = css`
  background: white;
`

const Report = (props) => {
  return (
      <div css={reportWrapper}>
        <div className={'date'}>{ props.date }</div>
        <div><Typography variant={'h1'} className={'title'}>{ props.title }</Typography></div>
        <div css={{display:'flex', alignItems: 'center'}}>
          <div css={{minWidth: '120px'}}>
            {
              props.gender === '男性' &&
              <GenderIconMan css={genderIcon}/>
              ||
              <GenderIconWoman css={genderIcon}/>
            }
          </div>
          <div css={customerInfo}>
            <div className={'age'}>{ props.age }{ props.gender }</div>
            <div className={'situation'}>{ props.situation }</div>
          </div>
        </div>
        <div css={comment}>
          {
            props.comment
          }
        </div>
      </div>
  )
}

const comment = css`
  padding: 1rem;
  border-radius: 8px;
`

const customerInfo = css`
  padding: 1rem;
  .age {
    font-size: 2rem;
    padding: 0.5rem 1rem 1rem;
  }
  .situation {
    padding: 1rem;
    background-color: ${colorPalette.background.lightgray};
  }
`

const reportWrapper = css`
  margin-bottom: 24px;
  border: solid 1px ${colorPalette.primary};
  padding: 2rem;
  .date {
    text-align: left;
  }
  .title {
    font-weight: bold;
    text-align: left;
    padding: 1rem 0;
  }
`

const genderIcon = css`
  max-width: 120px;
`

const wrapper = css`
  padding: 24px 0;
`

const title = css`
  font-weight: bold;
  color: ${colorPalette.primary};
  padding: 1rem;
`

const subtitle = css`
  background-color: ${colorPalette.primary};
  padding: 0.5rem 1rem;
  max-width: 300px;
  text-align: center;
  margin: 0 auto;
  border-radius: 8px;
  color: ${colorPalette.white};
  font-weight: bold;
`